<template>
  <el-dialog class="setTitleDialog" title="设置表格" :visible.sync="modalInfo.isShow" :close-on-click-modal="false" @close="cancelModal" v-if="modalInfo.isShow" width="960px">
  <el-row class="main-wrap"  v-loading="loading">
    <el-col :span="18" class="left-wrap">
      <h4 class="header">可用字段</h4>
			<div class="wrap">
				<div class="base-fields" v-if="numType != 4 && numType != 5">
					<h5>基本字段</h5>
					<el-checkbox-group v-model="selectionData"  @change="getSelected">
						<span class="item-check" v-for="(item,i) in baseFields" :key="i">
              <el-tooltip class="item" effect="dark" :content="item.fieldname" placement="top">
                <el-checkbox :label="item" :disabled="item.fieldRequired == 1">{{item.fieldname}}</el-checkbox>
              </el-tooltip>
						</span>
					</el-checkbox-group>
				</div>
				<div class="self-fields">
          <h5 v-if="numType != 5">自定义字段</h5>
					<h5 v-else>基本字段</h5>
					<div class="item-wrap">
						<el-checkbox-group v-model="selectionData"  @change="getSelected">
							<span class="item-check" v-for="(item,i) in selfFields" :key="i" @mouseover="hoverKeyChange(item)">
								<span class="item-check-input" v-if="isItemInputkey == item.id">
									<el-input v-model="editValue" maxlength="10" show-word-limit size="mini" clearable></el-input>
									<span class="opt">
                    <i class="el-icon-check" @click="confirmAddField(item)"></i>&nbsp;
                    <i class="el-icon-close" @click="isItemInputkey=''"></i>
                  </span>
								</span>
								<span class="item-check-label" v-if="isItemInputkey != item.id">
                  <el-tooltip class="item" effect="dark" :content="item.fieldname" placement="top">
                    <el-checkbox :label="item" :disabled="item.fieldRequired == 1">{{item.fieldname}}</el-checkbox>
                  </el-tooltip>
									<span class="opt-wrap" :class="hoverKey == item.id ?'activeHover':''" v-if="numType != 5">
										<i class="el-icon-edit-outline" @click="isItemInputkey = item.id;editValue=item.fieldname;"></i>
										<i class="el-icon-delete" @click="deleteField(item)"></i>
									</span>
								</span>
							</span>
							<span class="add" v-if="isAddBtn && numType != 5" @click="isAddBtn = false;addValue=''"><i class="el-icon-circle-plus-outline"></i>新增</span>
							<div class="item-check" v-else>
								<el-input v-model.trim="addValue" maxlength="10" show-word-limit size="mini" clearable v-if="numType != 5"></el-input>
								<span class="opt" v-if="numType != 5">
                  <i class="el-icon-check" @click="confirmAddField(null)"></i>&nbsp;
                  <i class="el-icon-close" @click="isAddBtn = true;"></i>
                </span>
							</div>
						</el-checkbox-group>
					</div>
				</div>
			</div>
    </el-col>
    <el-col :span="6" class="select-fields">
      	<h4 class="header">已选字段</h4>
		<div class="select-list">

			<el-tree :data="selectionData2"
        ref="tree"
				node-key="id"
				default-expand-all
				draggable
				:highlight-current="true"
				:allow-drop="allowDrop"
				@node-drop="handleDrop"
				:props="treeProps"
        style="position: relative;"
				>
				<span class="custom-tree-node" slot-scope="{ node, data }">
					<img src="../../assets/img/sort.jpg" alt="">{{ node.label }}
					<i v-if="node.data.fieldRequired != '1' && node.data.type != 1" @click="deleteNode(node.data,data)" class="el-icon-circle-close" style="float: right;line-height: 22px;"></i>
				</span>
			</el-tree>
			<!-- <div class="foot">
        <div style="margin-left: 15px;">
          按上下拖动可排序
        </div>
      </div> -->
		</div>
    </el-col>
  </el-row>
  <div slot="footer" class="dialog-footer">
    <el-button size="small" type="primary" class="confirm" @click="saveModel(false)" v-if="numType == 5">确 定</el-button>
  	<el-button size="small" type="primary" class="confirm" @click="confirmClick(false)" v-else>确 定</el-button>
    <el-button size="small" class="cancel" @click="cancelModal">取 消</el-button>
  </div>
  </el-dialog>
</template>
<script>
import {fetchGet,fetchPost} from "@/libs/reqCommon";
import {renderDialog} from "@/libs/renderCommon";
import axios from "axios";
export default {
	name:"setTableTitle",
	props:{
		modalInfo:{
			type:Object,
			default:()=>{}
		},
    numType:{
			type:Number,
			default:()=>{}
		},
	},
	data(){
		return{
			loading:true,
			addValue:"",
			editValue:"",
			isAddBtn:true,
			hoverKey:'',
			isItemInputkey:'',

			treeProps:{
				label:'fieldname'
			},
			baseFields:[],
      selfFields:[],
			selectionData:[],
			moduleName:'',
      selectionData2:[],
      newSelection:[],
		}
	},
	methods:{
    // 违规检索数据统计
    retrieveLowPrice(data) {
      this.loading = false
      this.selfFields = []
      this.selectionData = []
      this.selectionData2 = []
      for (let a in data) {
        if (data[a].type == 2) {
          this.selfFields.push(data[a])
          if (data[a].showtype == 1) {
            this.selectionData.push(data[a])
            this.selectionData2.push(data[a])
          }
        } else if (data[a].type == 1) {
          this.selectionData2.push(data[a])
        }
      }
      this.newSelection = this.selectionData2
    },
		hoverKeyChange(item){
			this.hoverKey = item.id;
		},
		// 获取字段数据
		getFildData(moduleName){
			this.loading = true;
			this.moduleName = moduleName;
			let query = { module:moduleName}
			fetchGet("/hcm/hcmCustomModel/getBybmcidAndModule",query).then(res =>{
				if(res.status == "10000"){
					this.baseFields=[];this.selfFields=[];this.selectionData=[],this.selectionData2=[],
          this.forColum(res.data.basic.data.concat(res.data.add.data))
				}
			});
		},
		// 处理字段数据
		forColum(titles){
			titles.sort(this.compare("id"))
			for (var i=0;i<titles.length;i++) {
				let field = titles[i];
				if(titles[i].isChecked)
				this.selectionData.push(field)
				if(titles[i].fieldClassify == "basic"){
					this.baseFields.push(field)
				}
				if(titles[i].fieldClassify == "add")
				this.selfFields.push(field)
			}
      this.selectionData2 = JSON.parse(JSON.stringify(this.selectionData))
      this.selectionData2.sort(this.compare("sort"))
			this.loading = false;
		},
		// 字段排序
		compare (prop) {
			return function (obj1, obj2) {
				var val1 = obj1[prop];
				var val2 = obj2[prop];if (val1 < val2) {
					return -1;
				} else if (val1 > val2) {
					return 1;
				} else {
					return 0;
				}
			}
		},
		// 删除已选节点
		deleteNode(item){
      if (this.numType == 5) {
        for (let i in this.selectionData2) {
          if (this.selectionData2[i].fieldvalue === item.fieldvalue) {
            this.selectionData2.splice(i,1)
          }
        }
        for (let i in this.selectionData) {
          if (this.selectionData[i].fieldvalue === item.fieldvalue) {
            this.selectionData.splice(i,1)
          }
        }
      } else {
        for (let i in this.selectionData2) {
          if (this.selectionData2[i].fieldvalue === item.fieldvalue) {
            this.selectionData2.splice(i,1)
          }
        }
        // selectionData2
  			var newArr = this.selectionData.filter(function(obj){
  				return item.id != obj.id;
  			});
  			this.selectionData = newArr;
        this.selectionData2.sort(this.compare("sort"))
      }

		},
		// 获取已选的项
		getSelected(value){
      if (this.numType == 5) {
        this.selectionData2 = this.newSelection.concat(value)
      } else {
        this.selectionData2 = Object.assign([],value);
      }
		},
		// 新增自定义字段请求
		reqSaveFields(query){
			fetchPost("/hcm/hcmCustomModel/save",query).then(res =>{
				if(res.status == "10000"){
					this.isItemInputkey = "";
					this.getFildData(this.moduleName);
				}else{
					this.$message.error(res.message?res.message:'新增失败！');
				}
			});
		},
		// 新增/编辑自定义字段
		confirmAddField(item){
			if(this.addValue||this.editValue){
				let query = {
					fieldClassify: "add",
					fieldname: this.addValue,
					module: this.moduleName,
				}
				if(item){
					query.fieldname = this.editValue
					query.id = item.id
				}
				this.reqSaveFields(query);
				this.isAddBtn = true;
			}else{
				this.$message.info('字段名不能为空！');
			}
		},
		// 删除自定义字段
		deleteField(item){
			let query = {
				id:item.id,
				module: this.moduleName
			}
			let url = "/hcm/hcmCustomModel/delete"
			let func = this.reqDelete
			let info = {
				title:`你确定要删除该字段吗？`,
				infoccc:'删除后',infored:`录入的信息会被删除`
			}
			renderDialog(info,url,query,func,this)
		},
		// 删除请求
		reqDelete(query,url){
			fetchPost(url,query).then(res =>{
				if(res.status == "10000"){
					this.getFildData(this.moduleName);
					this.$message.success('删除成功！');
				}else{
					this.$message.error('删除失败！');
				}
			})
		},
		// 设置表头确认
		confirmClick(sort){
			let ids = [];
      let names = [];
			for(let item of this.selectionData2){
				let id = item.id;
				ids.push(id);
        let name = item.fieldname;
				names.push(name);
			}
			let query = {
				ids:String(ids),
				module: this.moduleName,
        names:String(names),
			}
			fetchPost("/hcm/hcmCustomModel/saveSort",query).then(res =>{
				if(res.status == "10000"){
					if(!sort){
						this.$emit("reqTableData")
						this.modalInfo.isShow = false;
						this.$message.success('设置表头字段成功！');
					}
				}
			});
		},
    // 设置表头确认
    saveModel() {
      let that = this
      let a = this.selfFields
      let b = this.selectionData
      let query = this.array_diff(a, b)
      axios({
        method: 'post',
        url: 'hcm/iprViolationRetrieveModel/saveModel',
        headers: {
         'Content-type': 'application/json;charset=UTF-8'
        },
        data: query,
        timeout: 60 * 1000 * 50
      }).then(function (response) {
        if (response.data.status == "10000") {
					that.$emit("reqTableData")
					that.modalInfo.isShow = false;
					that.$message.success('设置表头字段成功！');
        } else {
          that.$message.error(response.data.message)
        }
      }).catch(err => {
        that.$message.error(response.data.message);
      });
    },
    array_diff(a, b) {
      for (var i = 0; i < b.length; i++) {
        for (var j = 0; j < a.length; j++) {
          if (a[j].fieldvalue == b[i].fieldvalue) {
            a.splice(j, 1);
            j = j - 1;
          }
        }
      }
      return a;
    },
		// 拖动排序
		allowDrop(draggingNode, dropNode, type) {
			if (draggingNode.data.level === dropNode.data.level) {
				if (draggingNode.data.aboveId === dropNode.data.aboveId) {
					return type === 'prev' || type === 'next'
				}
			}
			else return false
		},
		// 拖拽成功时触发
		handleDrop(draggingNode, dropNode, dropType, ev) {
			// this.confirmClick(true)
		},
		cancelModal(){
			this.addValue=""
			this.editValue=""
			this.isAddBtn=true
			this.hoverKey=''
			this.isItemInputkey=''
			this.modalInfo.isShow = false
		}
	}
}
</script>
<style lang="scss">
$highColor:#108cee;
.setTitleDialog{
  .el-dialog__body {
    padding: 20px 24px !important;
  }
  .el-tree-node__content {
    padding: 3px !important;
  }
	.main-wrap{
		border: 1px solid rgb(221, 221, 221);
		// margin: 20px 0;
		.header{
			padding: 0 0 0 10px;
			line-height: 40px;
			background: #eee;
			margin: 0;
		}
		.wrap{
			padding: 0 0 10px 16px;
		}
		.el-checkbox-group{
			font-size: 14px;
		}
		.item-check{
			padding: 0 16px 8px 0;
			display: inline-block;
			width: 28%;
			.el-checkbox__label{
				margin-right: 5px;
				overflow: hidden;
    			white-space: nowrap;
    			text-overflow: ellipsis;
    			max-width: 130px;
    			vertical-align: sub;
			}
			i{
				padding: 0 5px 0 5px;
				color: $highColor;
				cursor: pointer;
			}
		}
		.self-fields{
			position: relative;
			.item-check{
    			white-space: nowrap;
				&:hover .opt-wrap{
					visibility: visible;
				}
				.el-input{
					width: calc(100% - 30px);
				}
			}
			.opt-wrap{
				visibility: hidden;
				&.activeHover{
					visibility: visible;
				}
        &.activeHover{
					visibility: hidden;
				}
			}
			.add{
				color: $highColor;
				cursor: pointer;
				white-space: nowrap;
			}
		}
		.select-fields{
			height: 520px;
			border-left: 1px solid rgb(221, 221, 221);
			li{
				display: block;
				padding: 10px 0 0 10px;
				i{ padding: 0 4px 0 0}
			}
		}
		.select-list{
			height: calc(100% - 40px);
    		overflow-y: auto;
		}
		.left-wrap{
			height: 520px;
			.wrap{
				height: calc(100% - 50px);
				overflow-y: auto;
			}
		}
	}
	.el-tree{
		min-height: 328px;
	}
	.el-tree__drop-indicator{
		height: 0;
	}
	.el-tree-node .el-tree-node__content{
		margin: 5px 0;
		&:hover{
			background-color: #e6f7ff!important;
		}
	}
	.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
		background-color: #bae7ff
	}
	// .foot{
  //   color: #999;
  //   padding: 7px;
  //   margin: 0;
  //   position: absolute;
  //   bottom: 231px;
  //   border-left: 1px solid #dddddd;
  //   height: 12px;
  //   top: 494px;
  //   left: 683px;
	// }
	.custom-tree-node{
		width: 100%;
		img{
			padding-right: 6px;
    	vertical-align: middle;
		}
	}
}
</style>
